import appError from './appError.js';

/**
 * Result of Object.prototype.toString.call(*)
 * @param {*} value
 * @returns {string}
 */
const toString = function(value) {
	return Object.prototype.toString.call(value);
};

/**
 * Strictly compare value type
 * @param {*} value
 * @param {string} expectedType
 * @returns {boolean}
 */
const strictCompare = function(value, expectedType) {
	return toString(value).toLowerCase() === `[object ${expectedType}]`;
};

/**
 * Compare value type
 * @param {*} value
 * @param {string} expectedType
 * @returns {boolean}
 */
const basicCompare = function(value, expectedType) {
	return typeof value === expectedType;
};

/**
 * Check the value type
 * @param {*} value
 * @param {string} expectedType
 * @param {boolean} strict
 * @returns {boolean}
 */
const checkType = function(value, expectedType, strict) {
	if (strict) {
		return strictCompare(value, expectedType);
	} else {
		return basicCompare(value, expectedType);
	}
};

/**
 * Function for type checking
 * @param {string} method
 * @param {object} types
 * @param {object} [context={}] Additional context to the appError (eg. session)
 */
export default (method, types, context = {}) => {
	Object.entries(types).forEach(([parameter, [value, expectedType, strict = false]]) => {
		let isValid = false;
		let expectedMessage = expectedType;
		const gotMessage = strict ? toString(value).toLowerCase() : typeof value;
		if (Array.isArray(expectedType)) {
			isValid = expectedType.some((type) => checkType(value, type, strict));
			expectedMessage = expectedType.map((type) => toString(type)).join('|');
		} else {
			isValid = checkType(value, expectedType, strict);
		}
		if (!isValid) {
			throw appError(`Invalid method arguments to ${method}`, {
				code: 'APP_SHARED_UTIL',
				origin: 'checkTypes',
				description: `METHOD: ${method} | PARAMETER: ${parameter} | EXPECTED: ${expectedMessage} | GOT: ${gotMessage}`,
				detail: {
					checkTypes: {
						parameter,
						value,
						expectedType,
						strict
					},
					...context
				}
			});
		}
	});
};
